import { z } from 'zod'
import { de } from 'zod/locales'
import { t } from 'i18next'

/**
 * Custom Zod error map using our i18n translations.
 */
const zodCustomErrorMap: z.core.$ZodErrorMap = (issue) => {
  switch (issue.code) {
    case 'too_big':
      if (issue.origin === 'string') {
        return t('ui-validation:string.maxLength', {
          count: Number(issue.maximum)
        })
      }
      if (issue.origin === 'array') {
        return t('ui-validation:array.max', { count: Number(issue.maximum) })
      }
      return undefined

    case 'too_small':
      if (issue.origin === 'string') {
        return t('ui-validation:string.minLength', {
          count: Number(issue.minimum)
        })
      }
      if (issue.origin === 'array') {
        return t('ui-validation:array.min', { count: Number(issue.minimum) })
      }
      return undefined

    case 'invalid_type':
      if (issue.input === undefined || issue.input === null) {
        return t('ui-validation:common.required')
      }
      return t('ui-validation:common.invalid')

    case 'invalid_value':
      return t('ui-validation:select.pleaseSelect')

    case 'invalid_format': {
      const formatIssue = issue as z.core.$ZodIssueInvalidStringFormat
      switch (formatIssue.format) {
        case 'email':
          return t('ui-validation:string.invalidEmail')
        case 'url':
          return t('ui-validation:string.invalidUrl')
        case 'uuid':
        case 'uuidv4':
        case 'uuidv6':
        case 'guid':
          return t('ui-validation:string.invalidUuid')
        case 'date':
        case 'datetime':
        case 'time':
          return t('ui-validation:date.invalid')
        case 'regex':
          return t('ui-validation:string.invalidCharacters')
        default:
          return undefined
      }
    }

    case 'unrecognized_keys':
    case 'invalid_union':
    case 'invalid_key':
    case 'invalid_element':
      return t('ui-validation:common.invalid')

    case 'custom':
    default:
      return undefined
  }
}

export function initializeZodI18n() {
  const zodDe = de()
  z.config({
    customError: zodCustomErrorMap,
    localeError: zodDe.localeError
  })
}
